import * as React from 'react';

import { View } from '@longline/aqua-ui/controls/View';
import { Form } from '@longline/aqua-ui/containers/Form';
import { Input } from '@longline/aqua-ui/inputs/Input';
import { CountryDropdown } from '@longline/aqua-ui/modules/CountryDropdown';

import { IUser } from '../../../api/models';
import { RoleControl } from '../AddUser/RoleControl';
import { Grid } from '../../../ui/Grid';

interface IProps {
  user: IUser;
  onChange: (profile: IUser, forceUpdate: boolean) => void;
  onValidate: (valid: boolean) => void;
  disabled?: boolean;
  dirty?: boolean;
}

const EditUserForm = (props: IProps) =>
  <Form
    data={props.user}
    onChange={props.onChange}
    onValidate={props.onValidate}
    dirty={props.dirty}
  >
    <Grid>
      <Grid.Item weight={6}>
        <View label="email" hint="User email address">{props.user.email}</View>
      </Grid.Item>
      <Grid.Item weight={6}>
        <Form.Field
          rules={{
            required: { message: "Name is required." }
          }}
          name="name"
          value={props.user.name}
          label="Name"
          disabled={props.disabled}
          wrapper='box'
          control={(
            <Input
              transparent
              type="text"
              placeholder="Name"
              fluid
            />
          )}
          hint={<>The user's <b>name</b>.</>}
        />
      </Grid.Item>      
      <Grid.Item weight={6}>
        <Form.Field
          rules={{
          }}
          name="country"
          value={props.user.country}
          label="Country"
          wrapper='box'
          control={(<CountryDropdown clearable fluid/>)}
          hint={<>User home country</>}
        />
      </Grid.Item>
      <Grid.Item weight={6}>
        <Form.Field
          rules={{
            pattern: { pattern: "^\\+[1-9]\\d{6,14}$", message: "Must be in international format, e.g. +447700900123." }
          }}
          name="phoneNumber"
          value={props.user.phoneNumber}
          label="Phone number"
          disabled={props.disabled}
          wrapper='box'
          control={(
            <Input
              transparent
              type="text"
              placeholder="+447700900123"
              fluid
            />
          )}
          hint={<>International format. Required for SMS login.</>}
        />
      </Grid.Item>
      <Grid.Item weight={6}>
        <Form.Field
          name="roles"
          label="Roles"
          value={props.user.roles ?? []}
          wrapper='box'
          disabled={props.disabled}
          control={<RoleControl/>}
          hint={<>The user's roles.</>}
        />              
      </Grid.Item>
    </Grid>
  </Form>

export { EditUserForm }

